import script from "./LibraryLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./LibraryLayout.vue?vue&type=script&setup=true&lang=ts"

import "./LibraryLayout.vue?vue&type=style&index=0&id=746fe16e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-746fe16e"]])

export default __exports__